import {AppHelper} from "../appHelper";
import {DialogHelper} from "../core/util/dialogHelper";
import {Config as config, Config} from "../core/config/config";
import {NotificationHelper} from "../core/util/notificationHelper";
import {General as general, General} from "../../siteManagement/general";
import {AppBaseProps, CommonApp, Context, Entity} from "../core/components/commonApp";
import {HTTPService, JsonResultClass} from "../core/util/httpManager";
import {Sheet, SheetEventType} from "../../siteManagement/sheet";
import {Helper} from "../core/util/helper";
import {ToolBoxCommand} from "../core/components/sortableTreeSlot";
import {SortableTreeNode, Tree} from "../core/components/sortableTree";
import RecurringTaskApp, {RecurringTaskAppProps, RecurringTaskEntity} from "../tasks/recurringTask/recurringTask";
import ChangeTaskGroupPeriodApp, {
    ChangeTaskGroupPeriodAppProps,
    ChangeTaskGroupPeriodEntity
} from "../tasks/recurringTask/changeTaskGroupPeriod";
import {MetaDataHelper} from "../core/util/metaDataHelper";
import ExecuteAllAppLauncher, {ExecuteAllAppLauncherProps} from "../tasks/recurringTask/executeAllTasks";
import ChangeTaskPeriodApp, {
    ChangePeriodEntity,
    ChangeTaskPeriodAppProps
} from "../tasks/recurringTask/changeTaskPeriod";
import TriggeringErrorListApp, {
    TriggeringErrorListAppProps,
    TriggeringErrorListEntity
} from "../tasks/recurringTask/triggeringErrorList";
import {ExecutionAssignmentInfo, TaskExecutionInfo} from "../resourcePlanningDialogs/resourcePlanningDeletionDialog";
import {
    openCancellationView,
    TaskPositionCancellingParam
} from "../tasks/taskCancellingPreview";
import { EnumEntity, StringKeyDictionary } from "../commonInterfaces";
import MonitorTreeApp from "../monitor/monitorTree";
import React from "react";

export default class TaskGroupApp extends React.Component<TaskGroupAppProps, TaskGroupAppState> {
    common = new AppHelper();
    setTabTitle = true;
    deleteEnabled: boolean = false;
    isDeleted: boolean;
    sheet: Sheet;
    private lockId: number;
    // Tree der Recurring Tasks
    private treeRef: Tree;

    constructor(props: TaskGroupAppProps) {
        super(props);
        this.common.init(this);
        if (this.props.entity.TaskGroup.RecordRight.CanWrite) {
            this.common.unloadHelper.addBeforeUnloadCallback(() => {
                this.releaseLock();
            });
        }
        this.refreshDeleteEnabled();
        this.state = {
            TreeView: this.createTreeNode(props.entity.TreeNode),
        };

        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.sheet.bind(SheetEventType.Custom, (data: any) => {
            if (Helper.hasValue(data) && data.command === "reset") {
                this.handleFieldChange({ model: data.field }, null);
            }
        });
    }

    private refreshDeleteEnabled() {
        this.deleteEnabled = !this.props.entity.TaskGroup.IsNew && this.props.entity.TaskGroup.RecordRight.CanWrite && this.props.entity.TaskGroup.ExplicitValues.State.Value !== TaskState.Active;
    }

    private removeNode = async (node: TaskRootNodeItem) => {
        let entity = this.findEntityChild(this.props.entity.TreeNode, node.StructureNodeId);
        let isOk = await DialogHelper.confirm(config.translations.deleteMessage);
        if (isOk) {
            if (node.Type === TaskItemType.Group) {
                let result = await HTTPService.post("TaskGroup/Delete", { id: entity.TaskGroup.Id });
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.PositionDeleted"));
                    if (!await this.save())
                        await this.reloadTreeData();
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            }
            else {
                let result = await HTTPService.post("RecurringTask/Delete", { id: entity.Task.Id });
                if (result.Code === 0) {
                    NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.Task.Msg.Deleted"));
                    if (!await this.save())
                        await this.reloadTreeData();
                }
                else {
                    NotificationHelper.showErrorMessage(result.Message);
                }
            }
        }
    }

    private removeTaskGroup = async () => {
        let isOk = await DialogHelper.confirm(config.translations.deleteMessage);
        if (isOk) {
            let result = await HTTPService.post("TaskGroup/Delete", { id: this.props.entity.TaskGroup.ExplicitValues.Id });
            if (result.Code === 0) {
                NotificationHelper.showSuccessMessage(Helper.getTranslation("Ressource.LöschenErfolgreich"));
                this.common.sheetWrapper.trigger(SheetEventType.ItemDeleted, this.props.entity);
                if (General.Sheet.Manager.getSheetsCount() > 1) {
                    this.common.sheetWrapper.hide();
                } else {
                    this.deleteEnabled = false;
                    this.isDeleted = true;
                    this.props.entity.TaskGroup.RecordRight.CanWrite = false;
                    this.setState({});
                    setTimeout(() => {
                        window.location.href = config.baseUrl + "DynamicSearch/TaskGroup";
                    }, 1000);
                }
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        }
    }

    remove = async () => {
        await this.removeTaskGroup();
    }
    releaseLock = () => {
        if (this.lockId != undefined) {
            clearInterval(this.lockId);
            Helper.releaseLock(this.props.entity.TaskGroup.IsId, "FST_RECURRING_TASKS");
            this.lockId = undefined;
        }
    }

    save = async () => {
        return await this.internalSave(async (): Promise<boolean> => {
            if (!this.props.context.standAlone) {
                this.common.sheetWrapper.hide();
            }
            return true;
        });
    }

    matchMergedProp = (fieldName: string): string => {
        let match = fieldName.match(/^entity\.TaskGroup\.(?:MergedValues|ExplicitValues)\.(\w+)$/);
        if (Helper.hasValue(match))
            return match[1];
        else
            return null;
    }

    updateProp = (prop: string, value: any) => {
        this.common.handleFieldChange({ model: 'entity.TaskGroup.ExplicitValues.' + prop }, value);
        let parentValue = MetaDataHelper.getFieldValue(this.props.entity, 'entity.TaskGroup.ParentValues.' + prop);
        let mergedValue = value;
        if (Helper.isNullOrEmpty(value) && Helper.hasValue(parentValue))
            mergedValue = parentValue;
        this.common.handleFieldChange({ model: 'entity.TaskGroup.MergedValues.' + prop }, mergedValue);

        if (Helper.hasValue(this.props.entity.TreeNode)) {
            this.common.handleFieldChange({ model: 'entity.TreeNode.TaskGroup.' + prop }, value);
            this.setState({ TreeView: this.createTreeNode(this.props.entity.TreeNode) }, () => {
                if (this.treeRef)
                    this.treeRef.refresh();
            });

        }
    }

    handleFieldChange = (field: { model: any; }, value: null, dataItem = null, isInit = false) => {
        let prop = this.matchMergedProp(field.model);
        if (Helper.hasValue(prop)) {
            this.updateProp(prop, value);
            if (prop === 'Knr') {
                let kennungToSet = Helper.hasValue(dataItem?.Kennung) ? dataItem.Kennung : null;
                this.updateProp('Kennung', kennungToSet);
            } else if (prop === 'AdrNo') {
                let adrNameToSet = Helper.hasValue(dataItem?.adrname) ? dataItem.adrname :
                    Helper.hasValue(dataItem?.AdrName) ? dataItem.AdrName : null;
                this.updateProp('AdrName', adrNameToSet);
            } else if (prop === 'ProjNo') {
                let projNo2ToSet = Helper.hasValue(dataItem?.projnr2) ? dataItem.projnr2 :
                    Helper.hasValue(dataItem?.ProjNr2) ? dataItem.ProjNr2 : null;
                this.updateProp('ProjNo2', projNo2ToSet);
            } else if (prop === 'OGrNr') {
                let obergruppeToSet = Helper.hasValue(dataItem?.Obergruppe) ? dataItem.Obergruppe : null;
                this.updateProp('Obergruppe', obergruppeToSet);
            }
        }
        else if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }

    internalSave = async (action: () => Promise<boolean>): Promise<boolean> => {
        if (this.common.validate()) {
            let result: JsonResultClass<TaskGroupForEditEntity>;
            result = await HTTPService.post<JsonResultClass<TaskGroupForEditEntity>>("TaskGroup/Update", {
                model: this.props.entity.TaskGroup
            });

            if (result.Code === 0) {
                if (this.props.entity.IsNew)
                    general.Functions.HistoryState.replaceState("TaskGroup/Edit?id=" + encodeURIComponent(result.Data.ExplicitValues.Id));
                Helper.updateEntity(this.props.entity.TaskGroup, result.Data);
                this.props.entity.IsNew = false;
                this.props.entity.RecordRight = JSON.parse(JSON.stringify(result.Data.RecordRight));
                this.refreshDeleteEnabled();
                this.props.context.keyVal1 = result.Data.ExplicitValues.Id;
                // todo - Locks für TaskGroup
                this.reloadTreeData().then();
                this.common.handlePostSave(true);
                NotificationHelper.showSuccessMessage(config.translations.savingSuccessfulMessage);
                return await action();
            } else {
                this.common.handlePostSave(false);
                NotificationHelper.showErrorMessage(result.Message);
                return false;
            }
        }
        return false;
    }

    // noinspection JSUnusedGlobalSymbols
    openExecuteAllTasks = async () => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(Helper.getTranslation("WebCRM.Tasks.ExecuteAll.ScheduleIntervalls"));
        sheet.bind(SheetEventType.SavedSuccessfully, () => {
            this.setState({}, () => {
                this.common.sheetWrapper.trigger(SheetEventType.Custom, {event: "Reloading"});
            });
        });
        sheet.show(() => {
            const props: ExecuteAllAppLauncherProps = {
                isWindow: true,
                afterTriggerAllExecutions: () => {
                    this.reloadTreeData();
                },
                entityPreallocation: (filter) => {
                    filter.TaskNo = this.props.entity.TaskGroup.ExplicitValues.Number;
                    return filter;
                }
            };

            sheet.mountContent(ExecuteAllAppLauncher, props);
        });
    }
    // noinspection JSUnusedGlobalSymbols
    canOpenAddProject = () => {
        if (!this.props.entity.TaskGroup.IsNew && this.common.unloadHelper.isEntitySaved()) {
            return true;
        } else {
            NotificationHelper.showWarningMessage(config.translations.saveDataFirst);
            return false;
        }
    }

    // noinspection JSUnusedGlobalSymbols
    startReactivating = async () => {
        if(this.props.entity.TaskGroup.MergedValues.State.Value != 3) 
        {
            NotificationHelper.showErrorMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.Reactivate.CancelledOnly"));
            return;
        }
        this.post("TaskGroup/Reactivating", { id: this.props.entity.TaskGroup.ExplicitValues.Id }, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ActivateSucceeded")).then();
    }
    componentDidMount() {
        if (Helper.hasValue(this.props.entity.TaskGroup.IsId) && this.lockId == undefined && this.props.entity.TaskGroup.RecordRight.CanWrite) {
            this.lockId = Helper.keepLockAlive("Lock.ashx", this.props.entity.TaskGroup.IsId, "FST_RECURRING_TASKS", 10000);
        }
    }

    handleIsSearchFieldFullObjectModel = (field: { model: any; }, dataItem: { adrnr: null; projnr: null; }) => {
        let match = this.matchMergedProp(field.model);
        if (Helper.hasValue(match)) {
            if (match === 'AdrNo') {
                this.handleFieldChange(field, dataItem ? dataItem.adrnr : null, dataItem);
            } else if (match === 'ProjNo') {
                this.handleFieldChange(field, dataItem ? dataItem.projnr : null, dataItem);
            }
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common, handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return <CommonApp {...props} />;
    }

    private createTreeNode = (taskStructureNode: TaskStructureEntity): Array<TaskRootNodeItem> => {
        let nodes: Array<TaskRootNodeItem> = [];
        if (Helper.hasValue(taskStructureNode)) {
            let node = this.FillTaskNode(taskStructureNode);
            nodes.push(node);
        }
        return nodes;
    }

    private getTaskRoot = (): RecurringTaskRoot => {
        return ({ Title: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Structure"), children: this.state.TreeView });
    }

    private FillTaskNode = (taskExecution: TaskStructureEntity): TaskRootNodeItem => {
        if (taskExecution.IsGroupNode) {
            let node: TaskGroupItem = {
                Level: taskExecution.Level,
                StructureNodeId: taskExecution.Id,
                TaskGroupId: taskExecution.TaskGroup.Id,
                Kennung: taskExecution.TaskGroup.Kennung,
                AdrNo: taskExecution.TaskGroup.AdrNo,
                AdrName: taskExecution.TaskGroup.AdrName,
                ProjNo: taskExecution.TaskGroup.ProjNo,
                ProjNo2: taskExecution.TaskGroup.ProjNo2,
                MainGroupNo: taskExecution.TaskGroup.OGrNr,
                MainGroup: taskExecution.TaskGroup.Obergruppe,
                Type: TaskItemType.Group,
                LockMessage: "",
                StartsOnStr: Helper.hasValue(taskExecution.TaskGroup.StartsOn) ? taskExecution.TaskGroup.StartsOn.toString() : "",
                Title: taskExecution.TaskGroup.Title,
                State: taskExecution.TaskGroup.State,
                StartsOn: taskExecution.TaskGroup.StartsOn,
                EndsOn: taskExecution.TaskGroup.EndsOn,
                hasErrors: taskExecution.TaskGroup.TaskErrorCount > 0 || taskExecution.TaskGroup.ExecutionErrorCount > 0,
                collapsed: false,
                children: []
            };
            taskExecution.Items.forEach(t => {
                node.children.push(this.FillTaskNode(t));
            });
            return node;
        }
        else {
            // noinspection UnnecessaryLocalVariableJS
            let node: TaskItem = {
                TaskId: taskExecution.Task.Id,
                StructureNodeId: taskExecution.Id,
                Type: TaskItemType.Task,
                StartsOnStr: Helper.hasValue(taskExecution.Task.StartsOn) ? taskExecution.Task.StartsOn.toString() : "",
                Kennung: taskExecution.Task.Kennung,
                MainGroupNo: taskExecution.Task.OGrNr,
                MainGroup: taskExecution.Task.Obergruppe,
                Title: taskExecution.Task.Title,
                State: taskExecution.Task.State,
                StartsOn: taskExecution.Task.StartsOn,
                EndsOn: taskExecution.Task.EndsOn,
                AdrNo: taskExecution.Task.AdrNo,
                AdrName: taskExecution.Task.AdrName,
                ProjNo: taskExecution.Task.ProjNo,
                ProjNo2: taskExecution.Task.ProjNo2,
                Recurring: taskExecution.Task.Recurring,
                hasErrors: taskExecution.Task.TaskErrorCount > 0 || taskExecution.Task.ExecutionErrorCount > 0,
                collapsed: true,
                children: []
            };
            return node;
        }
    }
    private canShowCommand = (type: ToolBoxCommand, node: TreeLineItem, name?: string): boolean => {
        if (type != ToolBoxCommand.Custom) {
            return false;
        }
        else {
            let parent = this.findParent(this.props.entity.TreeNode, node.StructureNodeId);
            let entity = this.findEntityChild(this.props.entity.TreeNode, node.StructureNodeId);
            if (name === "removeNode") {
                return entity !== null && entity.Level !== null && entity.Level > 0 &&
                    !this.props.entity.IsNew && this.props.entity.RecordRight.CanWrite &&
                    (Config.user.isSysAdmin ||
                        (entity.IsGroupNode ?
                            entity.TaskGroup.State.Value === 0 /*|| (entity.TaskGroup.State.Value === 1 && entity.Items.length === 0)*/ :
                            entity.Task.State.Value === 0))
            }
            else if (name === "activateNode") {
                return entity !== null && entity.Level !== null && entity.Level > 0 &&
                    (parent.IsGroupNode ? parent.TaskGroup.EffectiveState.Value === TaskState.Active : parent.Task.State.Value === TaskState.Active) &&
                    (entity.IsGroupNode ? entity.TaskGroup.State.Value === TaskState.Draft : entity.Task.State.Value === TaskState.Draft);
            }
            else if (name === "cancelNode" || name === "finishNode" || name === "changePeriod") {
                return entity !== null && entity.Level !== null && entity.Level > 0 &&
                    (parent.IsGroupNode ? parent.TaskGroup.EffectiveState.Value === TaskState.Active : parent.Task.State.Value === TaskState.Active) &&
                    (entity.IsGroupNode ? entity.TaskGroup.State.Value === TaskState.Active : entity.Task.State.Value === TaskState.Active);
            }
            else if (name == "reactivateNode") {
                if (entity === null || !this.props.entity.TaskGroup.ReactivatingEnabled)
                    return false;
                if (entity.IsGroupNode && entity.TaskGroup.State.Value === TaskState.Cancelled){
                    if (parent === null) return true;
                    return parent.TaskGroup.EffectiveState.Value === TaskState.Active;
                }  
                if (!entity.IsGroupNode && entity.Task.State.Value === TaskState.Cancelled){
                    if (parent === null) return true;
                    return parent.TaskGroup.EffectiveState.Value === TaskState.Active;
                }  return false;
            }
            else if (name == "resetErrors")
                return entity !== null && (entity.IsGroupNode ? entity.TaskGroup.TaskErrorCount + entity.TaskGroup.ExecutionErrorCount > 0 : entity.Task.TaskErrorCount + entity.Task.ExecutionErrorCount > 0);
            else if (name == "showErrors")
                return entity !== null && !entity.IsGroupNode && (entity.Task.TaskErrorCount + entity.Task.ExecutionErrorCount > 0);
            else if (name == "copyTask")
                return entity !== null && !entity.IsGroupNode && 
                    (parent.TaskGroup.EffectiveState.Value === TaskState.Active || parent.TaskGroup.EffectiveState.Value === TaskState.Draft) && 
                    this.props.entity.RecordRight.CanWrite;
            return node.Type == TaskItemType.Group && this.props.entity.TaskGroup.RecordRight.CanWrite &&
                (Helper.hasValue(parent) ?
                    (parent.TaskGroup.EffectiveState.Value === TaskState.Active || parent.TaskGroup.EffectiveState.Value === TaskState.Draft) : true) &&
                (Helper.hasValue(entity) ?
                    (entity.TaskGroup.State.Value === TaskState.Draft || entity.TaskGroup.State.Value === TaskState.Active) : true);
        }
    }

    // KT - wenn auf dem gerade editierenden Knoten aufgerufen, muss Result von der Route passend sein - TaskGroupNodeEditEntity.
    private post = async (route: string, data: { id: string, individualFields?: {} }, successTranslation: string): Promise<boolean> => {
        let updatingMainEntity = data.id == this.props.entity.TaskGroup.ExplicitValues.Id;
        let action = async (): Promise<boolean> => {
            let result = await HTTPService.post<JsonResultClass>(route, data);
            if (result.Code === 0) {
                if (updatingMainEntity)
                    Helper.updateEntity(this.props.entity, result.Data);
                NotificationHelper.showSuccessMessage(successTranslation);
                this.reloadTreeData().then();
                if (updatingMainEntity)
                    this.setState({});
                this.common.handlePostSave(result.Code === 0);
                return true;
            }
            NotificationHelper.showErrorMessage(result.Message);
            return false;
        }
        
        if(!updatingMainEntity || this.props.entity.TaskGroup.MergedValues.State.Value <= TaskState.Active)
            return await this.internalSave(action);
        else
            return await action();
    }
    
    cancelPosition = async (entity: TaskPositionCancellingParam, individualFields: {}): Promise<boolean> => {
        if (entity.IsGroupNode) {
            return await this.post("TaskGroup/Cancel", { id: entity.PositionId, individualFields }, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.CancelSucceeded"));
        }
        else {
            return await this.post("RecurringTask/Cancel", { id: entity.PositionId, individualFields }, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.CancelSucceeded"));
        }
    }

    private actionCall = (node: TaskRootNodeItem, action: string) => {
        let entity = this.findEntityChild(this.props.entity.TreeNode, node.StructureNodeId);
        if (action === "finish") {
            if (node.Type === TaskItemType.Group) {
                this.post("TaskGroup/Finish", { id: entity.TaskGroup.Id }, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.FinishSucceeded")).then();
            }
            else if (node.Type === TaskItemType.Task) {
                this.post("RecurringTask/Finish", { id: entity.Task.Id }, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.FinishSucceeded")).then();
            }
        }
        else if (action === "activate") {
            if (node.Type === TaskItemType.Group) {
                this.post("TaskGroup/Activate", { id: entity.TaskGroup.Id}, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ActivateSucceeded")).then();
            }
            else if (node.Type === TaskItemType.Task) {
                this.post("RecurringTask/Activate", { id: entity.Task.Id }, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ActivateSucceeded")).then();
            }
        }
        else if (action === "reactivate") {
            if (node.Type === TaskItemType.Group) {
                this.post("TaskGroup/Reactivating", { id: entity.TaskGroup.Id}, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ActivateSucceeded")).then();
            }
            else if (node.Type === TaskItemType.Task) {
                this.post("RecurringTask/Reactivating", { id: entity.Task.Id }, Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ActivateSucceeded")).then();
            }
        }
        else if (action === "cancel") {
            openCancellationView({ 
                PositionId: entity.TaskGroup?.Id || entity.Task?.Id,
                IsGroupNode: entity.IsGroupNode,
                Level: entity.Level,
                PositionNo: entity.TaskGroup?.Number || entity.Task?.TaskNo,
                PositionTitle: entity.TaskGroup?.Title || entity.Task?.Title
            }, this.cancelPosition).then();
        }
        else if (action === "changePeriod") {
            let title = this.GetTitle(entity, node.Type, false);
            if (node.Type === TaskItemType.Group) {
                this.changeTaskGroupPeriod(entity.TaskGroup.Id, title, async (data: any, sheet: Sheet): Promise<boolean> => {
                    let result = await HTTPService.post<JsonResultClass<TaskGroupNodeEditEntity>>(
                        "TaskGroup/ChangeTerms", {
                        id: data.entity.MergedProps.Id,
                        startsOn: data.entity.MergedProps.StartsOn,
                        endsOn: data.entity.MergedProps.EndsOn
                    });
                    this.checkSuccess(result.Code, result.Message, sheet);
                    return result.Code == 0;
                }).then();
            }
            else if (node.Type === TaskItemType.Task) {
                this.changeTaskPeriod(entity.Task.Id, title, async (data: any, sheet: Sheet) => {
                    let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/ChangePeriod", { model: data.entity });
                    this.checkSuccess(result.Code, result.Message, sheet);
                }).then();
            }
        }
        else if (action == "resetErrors") {
            if (node.Type === TaskItemType.Group) {
                this.resetErrorsGroup(entity.TaskGroup.Id).then();
            }
            else if (node.Type === TaskItemType.Task) {
                this.post("RecurringTask/ResetAllErrors", { id: entity.Task.Id }, Helper.getTranslation("WebCRM.Tasks.TaskGroup.ResetAllErrors")).then();
            }
        }
    }

    private resetErrorsGroup = async (taskGroupId: string): Promise<boolean> => {
        let result = await HTTPService.post<JsonResultClass<TaskGroupNodeEditEntity>>("TaskGroup/ResetAllErrorsForPosition", { id: taskGroupId });
        if (result.Code === 0) {
            Helper.updateEntity(this.props.entity, result.Data);
            this.reloadTreeData().then();
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.HaveResetAllErrors"));
            this.setState({});
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
        this.common.handlePostSave(result.Code === 0);
        return result.Code == 0;
    }

    private activateGroup = async (): Promise<boolean> => {
        let result = await HTTPService.post<JsonResultClass<TaskGroupNodeEditEntity>>("TaskGroup/Activate", { id: this.props.entity.TaskGroup.ExplicitValues.Id });
        if (result.Code === 0) {
            Helper.updateEntity(this.props.entity, result.Data);
            this.reloadTreeData().then();
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ActivateSucceeded"));
            this.setState({});
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
        this.common.handlePostSave(result.Code === 0);
        return result.Code == 0;
    }

    private finishGroup = async (): Promise<boolean> => {
        let result = await HTTPService.post<JsonResultClass<TaskGroupNodeEditEntity>>("TaskGroup/Finish", { id: this.props.entity.TaskGroup.ExplicitValues.Id });
        if (result.Code === 0) {
            Helper.updateEntity(this.props.entity, result.Data);
            this.reloadTreeData().then();
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.FinishSucceeded"));
            this.setState({});
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
        this.common.handlePostSave(result.Code === 0);
        return result.Code == 0;
    }

    private dialogQuestion = async (question: string, action: () => Promise<boolean>): Promise<boolean> => {
        const isOk = await DialogHelper.confirm(question);
        if (isOk)
            return await action();
        return false;
    }

    private showChangeTaskGroupPeriodSheet = (data: any, metadata: any, title: string, save: (data: any, sheet: Sheet) => Promise<boolean>): Promise<boolean> => {
        return new Promise<boolean>(resolve => {
            const sheet = General.Sheet.Manager.createSheet();

            sheet.show(() => {
                const changePeriodVm = data;
                changePeriodVm.RecordRight = {CanRead: true, CanWrite: true};
                const props: ChangeTaskGroupPeriodAppProps = {
                    entity: changePeriodVm,
                    title: title,
                    metadata: metadata,
                    context: {contextType: "changeTaskGroupPeriod"}
                };
                sheet.setTitle(title);
                sheet.mountContent(ChangeTaskGroupPeriodApp, props);
            });

            sheet.bind(SheetEventType.SavedSuccessfully, async (data: any) => {
                let res = await save(data, sheet);
                resolve(res);
            });
            
            sheet.bind(SheetEventType.Close, () => {
                resolve(false);
            })
        });
    }
    
    private changeTaskGroupPeriod = async (id: string, title: string, save: (data: any, sheet: Sheet) => Promise<boolean>) => {
        let result = await Promise.all([HTTPService.get<JsonResultClass<ChangeTaskGroupPeriodEntity>>("TaskGroup/InitChangeTerms?id=" + encodeURIComponent(id)), Helper.getMetaData("changeTaskGroupPeriod")]);
        if (result[0].Code === 0) {
            return await this.showChangeTaskGroupPeriodSheet(result[0].Data, result[1], title, save);
        }
        else NotificationHelper.showErrorMessage(result[0].Message);  
    }

    private checkSuccess(code: number, message: string, sheet: Sheet) {
        if (code === 0) {
            this.reloadTreeData().then();
            NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ChangePeriodSucceeded"));
            this.setState({});
            sheet.hide();
        }
        else {
            NotificationHelper.showErrorMessage(message);
        }
    }

    private changeTaskPeriod = async (id: string, title: string, save: Function) => {
        const sheet = General.Sheet.Manager.createSheet();
        let results = await Promise.all([HTTPService.get<JsonResultClass<ChangePeriodEntity>>("RecurringTask/InitChangePeriod?id=" + encodeURIComponent(id)), Helper.getMetaData("changeTaskPeriod")]);
        if (results[0].Code === 0) {
            sheet.show(() => {
                const changePeriodVm = results[0].Data;
                changePeriodVm.RecordRight = { CanRead: true, CanWrite: true };
                const props: ChangeTaskPeriodAppProps = {
                    entity: changePeriodVm,
                    title: title,
                    metadata: results[1],
                    context: { contextType: "changeTaskPeriod" },
                };
                sheet.setTitle(title);
                sheet.mountContent(ChangeTaskPeriodApp, props);

            });
        }
        else {
            NotificationHelper.showErrorMessage(results[0].Message);
        }

        sheet.bind(SheetEventType.SavedSuccessfully, async (data: any) => {
            save(data, sheet);
        });
    }

    // noinspection JSUnusedGlobalSymbols
    createMonitorTree = () => {
        return <MonitorTreeApp adrNr={this.props.entity.TaskGroup.MergedValues.AdrNo} 
                               furtherParams={{ recurring_task_id: this.props.entity.TaskGroup.ExplicitValues.Id }} 
                               common={this.common} treeFile={"fst_tree_files"}/>
    }

    activate = () => {
        this.internalSave(this.activateGroup).then();
    }

    finish = () => {
        this.dialogQuestion(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.FinishConfirmation"), async () => { return await this.internalSave(this.finishGroup); })
            .then();
    }

    cancel = () => {
        openCancellationView({
            PositionId: this.props.entity.TaskGroup.ExplicitValues.Id,
            IsGroupNode: true,
            Level: this.props.entity.TaskGroup.Level, // müsste immer 0 sein.
            PositionNo: this.props.entity.TaskGroup.ExplicitValues.Number,
            PositionTitle: this.props.entity.TaskGroup.ExplicitValues.Title
        }, this.cancelPosition).then();
    }

    resetErrors = () => {
        this.internalSave(() => this.resetErrorsGroup(this.props.entity.TaskGroup.ExplicitValues.Id))
            .then();
    }

    changeTaskGroupPeriodImpl = async (id: string, title: string): Promise<boolean> => {
        return await this.changeTaskGroupPeriod(id, title, async (data: any, sheet: Sheet): Promise<boolean> => {
            let result = await HTTPService.post<JsonResultClass<TaskGroupNodeEditEntity>>(
                "TaskGroup/ChangeTerms", {
                    id: data.entity.MergedProps.Id,
                    startsOn: data.entity.MergedProps.StartsOn,
                    endsOn: data.entity.MergedProps.EndsOn
                });
            if (result.Code === 0) {
                Helper.updateEntity(this.props.entity, result.Data);
                this.reloadTreeData().then();
                NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.TaskGroup.Msg.ChangePeriodSucceeded"));
                this.setState({});
                sheet.hide();
                return true;
            }
            else {
                NotificationHelper.showErrorMessage(result.Message);
            }
            return false;
        })
    }
    
    changePeriod = () => {
        let title = this.GetTitle(this.props.entity, TaskItemType.Group, true);
        this.internalSave(() => this.changeTaskGroupPeriodImpl(this.props.entity.TaskGroup.MergedValues.Id, title))
            .then();
    }

    private openTaskGroup = async (taskGroupId: string) => {
        let result = await Promise.all([HTTPService.get<JsonResultClass<TaskGroupForEditEntity>>('TaskGroup/Init/?id=' + taskGroupId), Helper.getMetaData("taskGroup")]);
        const sheet = General.Sheet.Manager.createSheet();
        const entity = result[0];

        if (entity.Code > 0) {
            NotificationHelper.showErrorMessage(entity.Message);
        } else {
            const props: TaskGroupAppProps = {
                context: {
                    key1: "entity.TaskGroup.ExplicitValues.Id",
                    keyVal1: taskGroupId,
                    contextType: "taskGroup",
                    translations: null,
                    standAlone: false
                },
                title: "",
                onChange: null,
                dataSources: {},
                entity: {
                    TaskGroup: entity.Data,
                    TreeNode: null,
                    IsNew: false,
                    RecordRight: entity.Data.RecordRight,
                    IsWatchable: entity.Data.IsWatchable,
                    IsWatched: entity.Data.IsWatched
                },
                metadata: result[1],
                isWindow: false,
                selectedTaskId: null,
                selectedTaskGroupId: null,
                selectedStructureNodeId: null,
                selectedType: null
            };

            sheet.bind(SheetEventType.SavedSuccessfully, () => {
                this.reloadTreeData();
            });
            sheet.bind(SheetEventType.ItemDeleted, () => {
                this.reloadTreeData();
            });
            sheet.show(() => {
                sheet.mountContent(TaskGroupApp, props);
            });
        }
    }

    private addTaskGroup = async (selectedNode: TaskGroupItem) => {
        let result = await HTTPService.post<JsonResultClass<TaskStructureEntity>>('TaskGroup/AddSubgroup', { taskGroupId: selectedNode.TaskGroupId });
        if (result.Code == 0) {
            this.addNodeToSelected(selectedNode, result.Data);

            this.openTaskGroup(result.Data.TaskGroup.Id).then();
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    private GetTitle(entity: any, itemType: TaskItemType, isNodeEntity: boolean) {
        if (itemType === TaskItemType.Group) {
            let titleKey = "WebCRM.Tasks.Title.ChangePeriod.Interval";
            if (entity.TaskGroup.Level > 0)
                titleKey = "WebCRM.Tasks.Title.ChangePeriod.Position";
            let title = isNodeEntity ? entity.TaskGroup.MergedValues.Title : entity.TaskGroup.Title;
            return Helper.getTranslation(titleKey).replace("{Title}", title);
        }
        else if (itemType == TaskItemType.Task) {
            return Helper.getTranslation("WebCRM.Tasks.Title.ChangePeriod.Cycle").replace("{Title}", entity.Task.Title);
        }
        return "";
    }

    private findChild(nodes: TaskRootNodeItem[], id: string): TaskRootNodeItem {
        let node = nodes.find(item => item.StructureNodeId === id);
        if (node != undefined) {
            return node;
        }
        for (let child of nodes) {
            let result = this.findChild(child.children, id);
            if (Helper.hasValue(result))
                return result;
        }
        return null;
    }
    
    private findParentNode(nodes: TaskRootNodeItem[], id: string, parent: TaskRootNodeItem): TaskRootNodeItem {
        let node = nodes.find(item => item.StructureNodeId === id);
        if (node != undefined) {
            return parent;
        }
        for (let child of nodes) {
            let result = this.findParentNode(child.children, id, child);
            if (Helper.hasValue(result))
                return result;
        }
        return null;
    }

    private findParent(node: TaskStructureEntity, id: string): TaskStructureEntity {
        for (let child of node.Items) {
            if (id === child.Id)
                return node;
            let result = this.findParent(child, id);
            if (Helper.hasValue(result))
                return result;
        }
        return null;
    }

    private findEntityChild(node: TaskStructureEntity, id: string): TaskStructureEntity {
        if (id === node.Id)
            return node;
        for (let child of node.Items) {
            let found = this.findEntityChild(child, id);
            if (found != null)
                return found;
        }
        return null;
    }

    private openRecurringTask = async (taskId: string) => {
        let result = await Promise.all([HTTPService.get<JsonResultClass<RecurringTaskEntity>>('RecurringTask/Init?id=' + taskId), Helper.getMetaData("recurringTask")]);
        const sheet = General.Sheet.Manager.createSheet();

        const entity = result[0];

        if (entity.Code > 0) {
            NotificationHelper.showErrorMessage(entity.Message);
        } else {
            const props: RecurringTaskAppProps = {
                context: {
                    key1: "entity.Id",
                    keyVal1: taskId,
                    contextType: "recurringTask",
                    workPackageGridOptions: null,
                    machineGridOptions: null,
                    standAlone: false
                },
                title: "",
                entity: entity.Data,
                metadata: result[1],
                dataSources: {},
                isWindow: false
            };

            sheet.bind(SheetEventType.SavedSuccessfully, () => {
                this.reloadTreeData();
            });
            sheet.bind(SheetEventType.ItemDeleted, () => {
                this.reloadTreeData();
            });
            sheet.show(() => {
                sheet.mountContent(RecurringTaskApp, props);
            });
        }
    }

    private addNodeToSelected(selectedNode: TaskRootNodeItem, newItem: TaskStructureEntity) {
        // wir haben zwei TreeSturkturen, müssen also beide aktualisieren.

        // erst mal verändern wir den dargestellten Baum - this.state.TreeView
        let copiedTree: TaskRootNodeItem[] = JSON.parse(JSON.stringify(this.state.TreeView));
        let copiedSelectedNode = this.findChild(copiedTree, selectedNode.StructureNodeId);

        let newNode: TaskRootNodeItem = this.FillTaskNode(newItem);
        copiedSelectedNode.children.push(newNode);

        // und dann den internen (vom Server erhaltenen) - this.props.entity.TreeNode
        let internalNode = this.findEntityChild(this.props.entity.TreeNode, selectedNode.StructureNodeId);
        internalNode.Items.push(newItem);

        // anschließend lösen wir die Aktualisierung der React-Komponente aus.
        this.setState({ TreeView: copiedTree, SelectedNode: newNode }, () => {
            this.treeRef.refresh(() => {
                this.treeRef.select(copiedSelectedNode);
            });
        });
    }

    private copyRecurrentTask = async (parent: TaskGroupItem, selectedNode: TaskItem) => {
        let result = await HTTPService.post<JsonResultClass<TaskStructureEntity>>('TaskGroup/CopyTask', 
            { taskId: selectedNode.TaskId, taskGroupId: parent.TaskGroupId });
        if (result.Code == 0) {
            this.addNodeToSelected(parent, result.Data);
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }
    
    private addRecurrenttask = async (selectedNode: TaskGroupItem) => {
        let result = await HTTPService.post<JsonResultClass<TaskStructureEntity>>('TaskGroup/AddSubtask', { taskGroupId: selectedNode.TaskGroupId });
        if (result.Code == 0) {
            this.addNodeToSelected(selectedNode, result.Data);

            this.openRecurringTask(result.Data.Task.Id).then();
        }
        else {
            NotificationHelper.showErrorMessage(result.Message);
        }
    }

    // noinspection JSUnusedGlobalSymbols
    renderTaskGroupStructure = () => {
        return (
            <div className="execution_treeview">
                <div className="flex-container flex-container__item " >
                    <div className="tree" style={{ width: "50%", minWidth: "600px", height: "100%", display: "flex", flexDirection: "column" }}>
                        <Tree ref={(r) => { this.treeRef = r }}
                            tree={this.getTaskRoot()}
                            isChangeAllowed={this.isChangeAllowed}
                            noderRenderer={this.contentRenderer}
                            rightContentRenderer={() => { return null; }}
                            afterSelect={this.handleSelect}
                            canBeSelected={this.isSelectAllowed}
                            canNotDrag={true}
                            commands={{
                                canShow: (type: ToolBoxCommand, node: SortableTreeNode, name?: string) => {
                                    return this.canShowCommand(type, node as TreeLineItem, name);
                                },
                                custom: [
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.AddPosition"),
                                        iconName: "folder",
                                        name: "group",
                                        onClick: async (_cmd, node: TaskGroupItem) => {
                                            if (this.common.entityChanged)
                                                await this.save();
                                            await this.addTaskGroup(node);
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.AddTask"),
                                        iconName: "plus",
                                        name: "task",
                                        onClick: async (_cmd, node: TaskGroupItem) => {
                                            if (this.common.entityChanged)
                                                await this.save();
                                            await this.addRecurrenttask(node);
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("Standard.Kopieren"),
                                        iconName: "copy",
                                        name: "copyTask",
                                        onClick: async (_cmd, node: TaskItem) => {
                                            if (this.common.entityChanged)
                                                await this.save();
                                            let parent = this.findParentNode(this.state.TreeView, node.StructureNodeId,null);
                                            await this.copyRecurrentTask(parent as TaskGroupItem, node);
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.DeletePosition"),
                                        iconName: "trash",
                                        name: "removeNode",
                                        onClick: async (_cmd, node: TaskRootNodeItem) => {
                                            await this.removeNode(node);
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.Activate"),
                                        iconName: "check-circle",
                                        name: "activateNode",
                                        onClick: (_cmd, node: TaskRootNodeItem) => {
                                            this.actionCall(node, "activate");
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.Reactivate"),
                                        iconName: "arrows-rotate",
                                        name: "reactivateNode",
                                        onClick: (_cmd, node: TaskRootNodeItem) => {
                                            this.actionCall(node, "reactivate");
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.Cancel"),
                                        iconName: "times",
                                        name: "cancelNode",
                                        onClick: (_cmd, node: TaskRootNodeItem) => {
                                            this.actionCall(node, "cancel");
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.Finish"),
                                        iconName: "flag-checkered",
                                        name: "finishNode",
                                        onClick: (_cmd, node: TaskRootNodeItem) => {
                                            this.actionCall(node, "finish");
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.Action.ChangePeriod"),
                                        iconName: "arrow-to-right",
                                        name: "changePeriod",
                                        onClick: (_cmd, node: TaskRootNodeItem) => {
                                            this.actionCall(node, "changePeriod")
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.Executions.ShowErrors"),
                                        iconName: "calendar-exclamation",
                                        name: "showErrors",
                                        onClick: async (_cmd, node: TaskItem) => {
                                            await this.showTaskErrors(node.TaskId);
                                        }
                                    },
                                    {
                                        hint: Helper.getTranslation("WebCRM.Tasks.TaskGroup.ResetAllErrors"),
                                        iconName: "broom",
                                        name: "resetErrors",
                                        onClick: (_cmd, node: TaskRootNodeItem) => {
                                            this.actionCall(node, "resetErrors")
                                        }
                                    }
                                ]
                            }}
                        />
                    </div>
                </div>
            </div>
        )
    }

    showTaskErrors = async (taskId: string) => {
        let result = await Promise.all([HTTPService.get<JsonResultClass<TriggeringErrorListEntity>>('RecurringTask/Errors?taskId=' + taskId), Helper.getMetaData("taskErrors")]);

        const entity = result[0];

        if (entity.Code > 0) {
            NotificationHelper.showErrorMessage(entity.Message);
            return;
        }

        const sheet = General.Sheet.Manager.createSheet();

        const props: TriggeringErrorListAppProps = {
            context: {
                key1: "entity.Id",
                keyVal1: taskId,
                contextType: "taskErrors"
            },
            entity: entity.Data,
            metadata: result[1],
            dataSources: {},
            isWindow: false,
            doResetAll: async (): Promise<boolean> => {
                await this.resetErrorsForTask(taskId);
                return true;
            }
        };

        // sheet.bind(SheetEventType.SavedSuccessfully, () => {
        // this.reloadTreeData();
        // });
        // sheet.bind(SheetEventType.ItemDeleted, () => {
        // this.reloadTreeData();
        // });
        sheet.show(() => {
            sheet.mountContent(TriggeringErrorListApp, props);
        });
    }

    private resetErrorsForTask = async (taskId: string): Promise<boolean> => {
        let result = await HTTPService.post<JsonResultClass<RecurringTaskEntity>>("RecurringTask/ResetAllErrors", { id: taskId });
        if (result.Code === 0) {
            await this.reloadTreeData();
            this.common.handlePostSave(true);
            // NotificationHelper.showSuccessMessage(Helper.getTranslation("WebCRM.Tasks.RecurringTask.SuccessFulCompleted"));
            return true;
        } else{
            NotificationHelper.showErrorMessage(result.Message);
            this.common.handlePostSave(false);
            return false;
        }
    }
    
    private reloadTreeData = async () => {
        if (this.props.entity.TaskGroup.Level == 0) {
            let result = await HTTPService.get<JsonResultClass<TaskStructureEntity>>('TaskGroup/InitStructure?id=' + this.props.entity.TaskGroup.ExplicitValues.Id);
            this.props.entity.TreeNode = result.Data;
            this.props.entity.TaskGroup.TaskErrorCount = result.Data.TaskGroup.TaskErrorCount;
            this.props.entity.TaskGroup.ExecutionErrorCount = result.Data.TaskGroup.ExecutionErrorCount;
            this.setState({ TreeView: this.createTreeNode(result.Data) }, () => {
                if (this.treeRef)
                    this.treeRef.refresh();
            });
        }
    }


    private isChangeAllowed = (): Promise<boolean> => {
        return new Promise<boolean>((resolve) => {
            resolve(false);
        });
    }
    private renderRootNode = (node: TaskRootNodeItem) => {
        let CssStyleDiv: React.CSSProperties = {
            marginBottom: "3px"
        };
        return (
            <div className="item item-card">
                <div className="title" style={CssStyleDiv}>
                    <div> {node.Title}</div>
                </div>
            </div>
        );
    }

    private renderGroup = (node: TaskGroupItem) => {
        let CssStyleDiv: React.CSSProperties = {
            marginBottom: "3px"
        };
        let stateLine = <div> {Helper.getTranslation("Field.fstasks.state")}: {node.State.Title} </div>;
        let kennungLine = (Helper.hasValue(node.Kennung))
            ? <div>{Helper.getTranslation("Field.Einsatz.kennung")}: {node.Kennung}</div>
            : null;
        let obergruppeLine = (Helper.hasValue(node.MainGroup))
            ? <div>{Helper.getTranslation("Field.Adresse.ogrnr")}: {node.MainGroup}</div>
            : null;
        let adressLine = (Helper.hasValue(node.AdrNo))
            ? <div>{node.AdrNo} {node.AdrName}</div>
            : null;
        let projectLine = (Helper.hasValue(node.ProjNo))
            ? <div>{Helper.getTranslation("Field.Vorgang.projnr")}: {node.ProjNo} {node.ProjNo2}</div> : null;
        let showStart = (Helper.hasValue(node) && Helper.hasValue(node.StartsOn));
        let showEnd = (Helper.hasValue(node) && Helper.hasValue(node.EndsOn));
        let startsOn = showStart
            ? <div style={CssStyleDiv}> {Helper.getTranslation("Field.fstasks.StartsAt")}: {kendo.toString(kendo.parseDate(node.StartsOn), 'd')} </div>
            : null;
        let endsOn = showEnd
            ? <div style={CssStyleDiv}> {Helper.getTranslation("Field.fstasks.EndsAt")}: {kendo.toString(kendo.parseDate(node.EndsOn), 'd')} </div>
            : null;
        let errorIcon = (node.hasErrors ? <div style={{ display: "inline-flex" }}><i className="far fa-calendar-exclamation" title={Helper.getTranslation("WebCRM.Tasks.TaskGroup.ConflictPlanIntervalCycle")} ></i></div> : null);
        let linkToOpen = node.Level > 0
            ? <div>
                <a onClick={() => { this.openTaskGroup(node.TaskGroupId).then() }}> {node.Title}</a> {errorIcon}
            </div>
            : <div>{node.Title} {errorIcon}</div>;
        return (
            <div className="item item-card">
                <div className="title" style={{ marginBottom: "3px" }}>
                    {linkToOpen}
                    {startsOn}
                    {endsOn}
                    {adressLine}
                    {projectLine}
                    {kennungLine}
                    {obergruppeLine}
                    {stateLine}
                </div>
            </div>
        );
    }

    private renderTask = (node: TaskItem) => {
        let CssStyleDiv: React.CSSProperties = {
            marginBottom: "3px"
        };
        const newLocal = node;
        let stateLine = <div> {Helper.getTranslation("Field.fstasks.state")}: {node.State.Title} </div>;
        let kennungLine = (Helper.hasValue(node.Kennung))
            ? <div>{Helper.getTranslation("Field.Einsatz.kennung")}: {node.Kennung}</div> : null;
        let obergruppeLine = (Helper.hasValue(node.MainGroup))
            ? <div>{Helper.getTranslation("Field.Adresse.ogrnr")}: {node.MainGroup}</div> : null;
        let isRecurring = node.Recurring
            ? <div>{Helper.getTranslation("WebCRM.Tasks.TaskGroup.Task.Recurring")}</div>
            : <div>{Helper.getTranslation("WebCRM.Tasks.TaskGroup.Task.Once")}</div>;
        let adressLine = (Helper.hasValue(node.AdrNo))
            ? <div>{node.AdrNo} {node.AdrName}</div> : null;
        let projectLine = (Helper.hasValue(node.ProjNo))
            ? <div>{Helper.getTranslation("Field.Vorgang.projnr")}: {node.ProjNo} {node.ProjNo2}</div>
            : null;
        let showStart = (Helper.hasValue(newLocal) && Helper.hasValue(newLocal.StartsOn));
        let showEnd = (Helper.hasValue(newLocal) && Helper.hasValue(newLocal.EndsOn));
        let startsOn = showStart
            ? <div style={CssStyleDiv}> {Helper.getTranslation("Field.fstasks.StartsAt")}: {kendo.toString(kendo.parseDate(newLocal.StartsOn), 'd')} </div>
            : null;
        let endsOn = showEnd
            ? <div style={CssStyleDiv}> {Helper.getTranslation("Field.fstasks.EndsAt")}: {kendo.toString(kendo.parseDate(newLocal.EndsOn), 'd')} </div>
            : null;
        let errorIcon = (node.hasErrors ? <div style={{ display: "inline-flex" }}><i className="far fa-calendar-circle-exclamation" title={Helper.getTranslation("WebCRM.Tasks.TaskGroup.ConflictPlan")} ></i></div> : null);
        return (
            <div className="item item-card">
                <div className="title" style={{ marginBottom: "3px" }}>
                    <div> <a onClick={() => { this.openRecurringTask(node.TaskId).then() }}> {node.Title}</a> {errorIcon}</div>
                    {startsOn}
                    {endsOn}
                    {adressLine}
                    {projectLine}
                    {kennungLine}
                    {obergruppeLine}
                    {isRecurring}
                    {stateLine}
                </div>
            </div>
        );
    }

    private contentRenderer = (node: TreeLineItem) => {
        if (node.Type == TaskItemType.Group) {
            return (this.renderGroup(node as TaskGroupItem));
        }
        else if (node.Type == TaskItemType.Task) {
            return (this.renderTask(node as TaskItem));
        }
        else {
            return (this.renderRootNode(node));
        }
    }

    
    private handleSelect = (node: any) => {
        let copiedEntity: any = JSON.parse(JSON.stringify(this.props.entity));
        
        copiedEntity.selectedTaskId = Helper.hasValue(node.TaskId) ? node.TaskId : null;
        copiedEntity.selectedTaskGroupId = Helper.hasValue(node.TaskGroupId) ? node.TaskGroupId : null;
        copiedEntity.selectedStructureNodeId = node.StructureNodeId;
        copiedEntity.selectedType = node.Type;
        
        Helper.updateEntity(this.props.entity, copiedEntity);
        this.setState({});
    }

    private isSelectAllowed = () => {
        return new Promise<boolean>((resolve) => {
            resolve(true);
        });
    }

}

export interface TaskGroupEntity {
    Id: string;
    Title: string;
    Number: string;
    State: EnumEntity<TaskState>;
    StateStr: string;
    AdrNo: string;
    AdrName: string;
    ProjNo: string;
    ProjNo2: string;
    StartsOn: string;
    EndsOn?: string;
    OGrNr?: number;
    Obergruppe: string;
    Knr?: number;
    Kennung: string;
    TaskErrorCount: number;
    ExecutionErrorCount: number;
    EffectiveState: EnumEntity<TaskState>;
}

export interface TaskGroupForEditEntity extends Entity {
    ParentValues: TaskGroupEntity;
    ExplicitValues: TaskGroupEntity;
    MergedValues: TaskGroupEntity;
    Pos: number;
    Psp: string;
    Level: number;

    IsId?: number;
    LockMessage: string;
    TaskErrorCount: number;
    ExecutionErrorCount: number;

    ExecutionMgmtEnabled: boolean;
    ReactivatingEnabled: boolean;
}

export interface TaskGroupNodeEditEntity extends Entity {
    TaskGroup: TaskGroupForEditEntity;
    TreeNode: TaskStructureEntity;
}

export interface TaskGroupAppProps extends AppBaseProps {
    entity: TaskGroupNodeEditEntity;
    context: TaskGroupAppContext;
    metadata: any;
    title: any;
    isWindow: boolean;
    onChange?: any;
    selectedTaskId?: string;
    selectedTaskGroupId?: string;
    selectedStructureNodeId?: string;
    selectedType?: TaskItemType;
}

export interface TaskStructureEntity {
    Id: string;
    Level: number;
    Pos: number;
    Psp: string;
    TaskGroup?: TaskGroupEntity;
    Task?: RecurringTaskInfo;
    IsGroupNode: boolean;
    Items: TaskStructureEntity[];
}

export interface RecurringTaskCancellingPreview {
    TaskExecutionInfos: TaskExecutionInfo[];
    ExecutionAssignments: ExecutionAssignmentInfo[];
    ConfirmationRequired: boolean;
    IndividualFields: {};
}

export interface TaskGroupAppContext extends Context {
    translations: StringKeyDictionary<string>;
    standAlone: boolean;
}

enum TaskState {
    Draft,
    Active,
    Finished,
    Cancelled,
}

interface TaskGroupAppState {
    TreeView?: Array<TaskRootNodeItem>;
    SelectedNode?: TaskRootNodeItem;
}
interface RecurringTaskRoot {
    Title: string;
    children: Array<TaskRootNodeItem>
}
export interface RecurringTaskInfo {
    Id: string;
    Recurring: boolean;
    TriggerOnInit: boolean;
    State: EnumEntity<TaskState>;
    TaskNo: string;
    AdrNo?: string;
    AdrName?: string;
    ProjNo?: string;
    ProjNo2?: string;
    StartsOn: string;
    EndsOn?: string;
    Title: string;
    OGrNr?: number;
    Obergruppe: string;
    KNr: number;
    Kennung: string;
    TriggerPerMachine: boolean;
    TaskErrorCount: number;
    ExecutionErrorCount: number;
}
interface TaskGroupInfo {
    TaskGroupId: string;
    AdrNo?: string;
    AdrName?: string;
    ProjNo?: string;
    ProjNo2?: string;
    MainGroupNo: number;
    MainGroup: string;
    Kennung?: string;
    StartsOn?: string;
    StartsOnStr?: string;
    EndsOn?: string;
    State: EnumEntity<TaskState>;
    Level: number;
    LockMessage: string;
}

interface TaskGroupItem extends TaskRootNodeItem, TaskGroupInfo {

}

interface TaskItem extends TaskRootNodeItem, TaskItemInfo {

}

interface TaskItemInfo {
    TaskId: string;
    Title: string;
    StartsOn: string;
    StartsOnStr: string;
    EndsOn?: string;
    State: EnumEntity<TaskState>;
    Kennung?: string;
    MainGroupNo?: number;
    MainGroup: string;
    AdrNo?: string;
    AdrName?: string;
    ProjNo?: string;
    ProjNo2?: string;
    Recurring: boolean;
}
interface TaskRootNodeItem {
    StructureNodeId: string;
    Type: TaskItemType;
    Title: string;
    hasErrors: boolean;
    collapsed?: boolean;
    children: Array<TaskRootNodeItem>
}

enum TaskItemType {
    Group,
    Task
}

export type TreeLineItem = TaskRootNodeItem;